import React, {Component} from 'react';
import { DatePicker } from 'antd';
import moment from 'moment';

const { MonthPicker, RangePicker, WeekPicker } = DatePicker;
/**
 * creat by tianruojun
 * @description 时间选择器
 * @class Date_rmt
 * @extends {Component}
 */
export default class Date_rmt extends Component {

    render() {
        let {placeholder,onChange,value} = this.props;
        return (
            <RangePicker
                ranges={{
                    '今天': [moment().startOf('day'), moment().endOf('day')],
                    '本月': [moment().startOf('month'), moment().endOf('month')],
                }}
                showTime
                value={value?.length ?  value.map(item=>item?moment(item):null) : value}
                placeholder={placeholder}
                format="YYYY/MM/DD HH:mm:ss"
                onOk={(dates)=>{
                    onChange(dates.map(date=>date.valueOf()))
                }}
                onChange={(dates)=>{
                    let val = [];
                    if(dates?.length) {
                        val = dates.map(date=>date.valueOf())
                    }
                    onChange(val)
                }}
            />
        )
    }

}